import { render, staticRenderFns } from "./DateCapacity.vue?vue&type=template&id=5636ec8b&scoped=true&"
import script from "./DateCapacity.vue?vue&type=script&lang=js&"
export * from "./DateCapacity.vue?vue&type=script&lang=js&"
import style0 from "./DateCapacity.vue?vue&type=style&index=0&id=5636ec8b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5636ec8b",
  null
  
)

export default component.exports